export function useShowMe() {
  const handleShowMe = (context, currentPath) => {
    const path = currentPath || window.location.pathname;
    if (["/", "/settings", "/plans", "/nfe/issuer"].includes(path)) {
      if (context.currentBranch) {
        if (context.currentBranch.branch_plan) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  return handleShowMe;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/CardUpgrade/hooks/index.js